import { WindowUtils } from '@atlassian/mpac-utils';
import { useCrossFlow } from '@atlassiansox/cross-flow-support';
import { useCallback } from 'react';
import { ATLASSIAN_APP_LIST, BITBUCKET_SIGNUP_URL, TRELLO_SIGNUP_URL } from './constants';
import { AtlassianAppTargets } from './types';
export const useMarketplaceCrossFlow = () => {
  const baseCrossflow = useCrossFlow();
  const crossFlow = useCallback(_ref => {
    let {
      onCrossFlow,
      targetProduct,
      sourceComponent,
      sourceContext
    } = _ref;
    if (baseCrossflow !== null && baseCrossflow !== void 0 && baseCrossflow.isEnabled && baseCrossflow !== null && baseCrossflow !== void 0 && baseCrossflow.apiV1) {
      onCrossFlow();
      switch (targetProduct) {
        case AtlassianAppTargets.TRELLO:
          WindowUtils.openPage(TRELLO_SIGNUP_URL, WindowUtils.BLANK_WINDOW);
          break;
        case AtlassianAppTargets.BITBUCKET:
          WindowUtils.openPage(BITBUCKET_SIGNUP_URL, WindowUtils.BLANK_WINDOW);
          break;
        default:
          baseCrossflow.apiV1.open({
            journey: 'get-started',
            sourceComponent,
            sourceContext,
            targetProduct,
            v1: true
          });
          break;
      }
    }
  }, [baseCrossflow]);
  return {
    crossFlow,
    crossFlowProducts: baseCrossflow !== null && baseCrossflow !== void 0 && baseCrossflow.isEnabled ? ATLASSIAN_APP_LIST : []
  };
};